<template>
    <div class="tw:flex tw:h-screen tw:overflow-hidden  tw:md:p-3 tw:bg-slate-950">
        <template v-if="configuracion">
            <LoadCssComponent :estilos="configuracion.css_back" class="tw:w-0 tw:h-0 tw:overflow-hidden" />
        </template>

        <AdminShellSidebar />

        <div class="tw:flex tw:flex-1 tw:min-w-0 tw:min-h-0 tw:flex-col">
            <main class="tw:flex tw:flex-1 tw:min-h-0 tw:flex-col tw:overflow-hidden tw:sm:rounded-xl tw:border tw:border-slate-300 tw:bg-white tw:text-slate-900">
                <AdminShellHeader />
                <div class="admin-content-scroll tw:flex-1 tw:min-h-0 tw:overflow-y-auto tw:bg-slate-50/60">
                    <transition name="fade" mode="out-in">
                        <router-view />
                    </transition>
                </div>
            </main>
        </div>

        <ModalCuentaAtrasCarrito @close="closeModal('carrito-terminado')" />
        <ModalCuentraAtrasAvisoCarrito
            :seconds-left="carrito ? carrito.seconds_left : 0"
            @close="closeModal('carrito-aviso')"
        />
    </div>
</template>

<script setup>
    import { computed, watch, getCurrentInstance } from 'vue';
    import store from '@/store';
    import AdminShellSidebar from '@/modules/admin/layout/components/AdminShellSidebar.vue';
    import AdminShellHeader from '@/modules/admin/layout/components/AdminShellHeader.vue';
    import LoadCssComponent from '@/components/css/LoadCssComponent';
    import ModalCuentaAtrasCarrito from '@/components/common/carrito/ModalCuentaAtrasCarrito.vue';
    import ModalCuentraAtrasAvisoCarrito from '@/components/common/carrito/ModalCuentraAtrasAvisoCarrito.vue';
    import { useHead } from '@/composables/common/seo/useHead';
    import { useAdminAssets } from '@/composables/admin/assets/useAdminAssets';
    import { useRouter } from '@/composables/common/router/useRouter';

    useHead('Admin');
    useAdminAssets();

    const router = useRouter();
    const instance = getCurrentInstance();

    const configuracion = computed(() => store.getters.getConfig);
    const carrito = computed(() => store.getters.getCarritoActivo);

    watch(
        () => (carrito.value ? carrito.value.seconds_left : null),
        secondsLeft => {
            if (secondsLeft === 0) {
                instance.proxy.$modal.show('carrito-terminado');
                router.push({ path: '/admin/eventos' });
            }
        }
    );

    function closeModal(name) {
        instance.proxy.$modal.hide(name);
    }
</script>

<style>
    .fade-enter-active, .fade-leave-active {
        transition: opacity .2s;
    }
    .fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
        opacity: 0;
    }
</style>

<style scoped>
    /* Barra general del contenido: más fina y sin botones ni track. */
    @supports not selector(::-webkit-scrollbar) {
        .admin-content-scroll {
            scrollbar-width: thin;
            scrollbar-color: rgba(148, 163, 184, 0.4) transparent;
        }
    }

    .admin-content-scroll::-webkit-scrollbar {
        width: 6px;
    }

    .admin-content-scroll::-webkit-scrollbar-track {
        background: transparent;
    }

    .admin-content-scroll::-webkit-scrollbar-thumb {
        background-color: rgba(148, 163, 184, 0.4);
        border-radius: 9999px;
    }

    .admin-content-scroll::-webkit-scrollbar-thumb:hover {
        background-color: rgba(148, 163, 184, 0.6);
    }

    .admin-content-scroll::-webkit-scrollbar-button {
        display: none;
        width: 0;
        height: 0;
    }
</style>
